// removed by extract-text-webpack-plugin
module.exports = {"list":"_386_k","item":"_3ZgHh","itemChecked":"vtrdd _3ZgHh","checkbox":"HnFwd","checkboxChecked":"_2tDub HnFwd","tick":"_21fwO","title":"_20nUa","subtitle":"_3ckh0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Checklist.css
// module id = 797
// module chunks = 0